import React from 'react';
import { useTranslation } from 'react-i18next';
import NodeList from './NodeList';
import './nodeConfig.less';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface OTAUpdateStatusProps {
  nodeCount: number;
  nodeType: String;
  data: any,
  filters?: any;
  succeededNodes: string[];
  failedNodes: string[];
}

const tableKeysToRender = ['deviceId', 'deviceName', 'firmwareType', 'lastFwVersion',
  'currentFwVersion', 'fwSyncStatus'];

function getListLength(nodeList: any[], key: any, inputStr: string | string[]) {
  return (
    nodeList?.filter((obj: any) =>
      Array.isArray(inputStr)
        ? inputStr.includes(obj?.[key])
        : obj?.[key] === inputStr
    )?.length || 0
  );
}

function getStatusCount(nodeList: any[], key: any) {
  return {
    succeeded: getListLength(nodeList, key, ['success', 'sync']),
    pending: getListLength(nodeList, key, 'pending'),
    failed: getListLength(nodeList, key, ['aborted', 'rejected', 'error'])
  };
}

const OTAUpdateStatus: React.FC<OTAUpdateStatusProps> = (props: any) => {
  const {
    nodeCount, nodeType, data, filters, succeededNodes,
    failedNodes
  } = props;
  const { t } = useTranslation();
  const SucceededNodesCondition = succeededNodes?.length > 0; 
  const FailedNodesCondition = failedNodes?.length > 0;

  function renderStatusDetails(nodeList: any[]) {
    const statusCount = getStatusCount(nodeList, 'fwSyncStatus');
    return (
      <div className="flex-space-between">
        <div>
          <span className="font-weight-bold">{`${t('Succeeded')}: `}</span>
          <span>{`${statusCount.succeeded}/${nodeList.length}`}</span>
        </div>
        <div>
          <span className="font-weight-bold">{`${t('Pending')}: `}</span>
          <span>{`${statusCount.pending}/${nodeList.length}`}</span>
        </div>
        <div>
          <span className="font-weight-bold">{`${t('Failed')}: `}</span>
          <span>{`${statusCount.failed}/${nodeList.length}`}</span>
        </div>
      </div>
    );
  }

  return(
    <div className='ota-update-status'>
      {/* Succeeded Nodes Section */}
      <div className= {SucceededNodesCondition ? "flex-column" : 'flex-column'}>
      <h3 className="font-weight-bold">{`${t('Succeeded Nodes')}: ` }</h3>
       {SucceededNodesCondition ? (
        <NodeList
          renderItems={tableKeysToRender}
          showSearch={false}
          isCheckable={false}
          data={data}
          displayRecords={5}
          filters={filters || { type: nodeType }}
          FilterStatus
        />
      ) : (
           <div className="margin-left-10 font-weight-bold margin-bottom-10" 
            style={{ textAlign: 'center' }}
          >
           {t('No Succeeded nodes')}
          </div>
        )}
       </div>

      {/* Will be removed in the future*/}
      {/* <div className={FailedNodesCondition ? "flex-column gap" : "failed-node-status flex-column gap"}>
        <h3 className="font-weight-bold status-failed-message">{`${t('Failed Nodes')}: ` }</h3>
        {FailedNodesCondition ? (
          <>
            <div className="error-message">
              {t('Below devices identifier update process has failed')}
              <ul>
                {failedNodes.map((node :any) => (
                  <li key={node}>{node}</li>
                ))}
              </ul>
            </div>
          </>
        ) : (
          <div className='update-status font-weight-bold margin-bottom-10' style={{ textAlign: 'center' }}>{t('No Failed nodes')}</div>
        )}
      </div> */}

    {/* Status Options Section */}
      <div>
        <div className='flex-row'>
          <h3 className="font-weight-bold" style={{ marginRight: 8 }}>
            {`${t('Categories status')}: `}
          </h3>
          
          <Tooltip
            title={
                  <div>
                    <div>{`${t('Succeeded')}: ${t('Sync')}, ${t('Success')}`}</div>
                    <div>{`${t('Pending')}: ${t('Pending')}`}</div>
                    <div>{`${t('Failed')}: ${t('Aborted')}, ${t('Rejected')}, ${t('Error')}`}</div>
                  </div>
            }
          >
            <InfoCircleOutlined style={{ marginLeft: -1, color: '#888', cursor: 'pointer', marginTop: 5 }} />
          </Tooltip>
        </div>
        <div className="status-options">
          {renderStatusDetails(data)}
        </div>
      </div>
    </div>
  );
};

export default OTAUpdateStatus;
